import React, { Component } from 'react'
import ReactCardFlip from 'react-card-flip'
import PropTypes from 'prop-types'

import { Input } from 'loyal-react'
import { CreditCardFront, CreditCardBack } from './.'
import Select from './Select'

import CreditCardFrontImage from '@loyal_images/payment/credit-card-front.png'
import CreditCardBackImage from '@loyal_images/payment/credit-card-back.png'

const messageErrorCredidNumber =
  'O número do cartão de crédito parece inválido.'

class CreditCard extends Component {
  state = {
    isFlipped: false,
    isBackCardVisible: false,
    errors: {}
  }

  handleFlipChange = e => {
    e.preventDefault()

    this.setState(prevState => ({ isFlipped: !prevState.isFlipped }))
    setTimeout(() => {
      this.setState({
        isBackCardVisible: this.state.isFlipped
      })
    }, 300)
  }

  validateCardNumber = ({ target: { value } }) => {
    if (value) {
      const brand = this.props.cardBrand()
      const errors = brand
        ? { ...this.state.errors, number: '' }
        : { ...this.state.errors, number: messageErrorCredidNumber }
      this.setState({ errors })
    }
  }

  render () {
    const {
      payment: {
        installments: { items },
        pointsCashConfig
      },
      creditCard,
      cardBrand
    } = this.props

    const brand = cardBrand()

    const installmentsCash =
      (pointsCashConfig && pointsCashConfig.parcelCashConfigurationModel) || []

    const installments = items.length > 0 ? items : installmentsCash

    return (
      <div className='payment-step h-auto row'>
        <div className='col-12 col-sm-6 px-0'>
          <div className='row'>
            <Select
              id='payment-installment'
              label='Parcelar em'
              className='col-12 mt-0'
              displayValue='description'
              selectedValue='parcel'
              options={installments}
              value={this.props.installmentSelected()}
              onChange={this.props.handleCreditCardChange}
              name={'installment'}
              required
            />
            <Input
              id='payment-card-number'
              label='Número do cartão'
              className='col-12 mt-2'
              required
              guide={false}
              mask={[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              name='number'
              onChange={this.props.handleCreditCardChange}
              value={creditCard.number}
              onBlur={this.validateCardNumber}
              data-error={this.state.errors.number}
              valid={
                this.state.errors.number && creditCard.number ? false : null
              }
            />
            <Input
              id='payment-card-person-name'
              label='Nome impresso no cartão'
              className='col-12 mt-2'
              required
              onChange={this.props.handleCreditCardChange}
              value={creditCard.personName}
              name='personName'
            />
            <Input
              id='payment-card-validity-date'
              label='Validade mês/ano'
              className='col-6 mt-2'
              mask={[/\d/, /\d/, '/', /\d/, /\d/]}
              required
              onChange={this.props.handleCreditCardChange}
              value={creditCard.validityDate}
              name={'validityDate'}
            />
            <Input
              id='payment-card-cvv'
              label='CVV'
              className='col-6 mt-2'
              mask={(typeof brand !== 'undefined' && brand.name === 'AmericanExpress' ? [/\d/, /\d/, /\d/, /\d/] : [/\d/, /\d/, /\d/])}
              required
              onFocus={this.handleFlipChange}
              onBlur={this.handleFlipChange}
              onChange={this.props.handleCreditCardChange}
              value={creditCard.cvv}
              name={'cvv'}
            />
          </div>
        </div>
        <div className='col-12 col-sm-6 d-none d-lg-block mt-3 mt-md-0'>
          <div className='row  align-items-center h-100'>
            <div className='col-12 txt-center pos-relative inserted'>
              <div className='image-credit-card front_credit-card'>
                <ReactCardFlip isFlipped={this.state.isFlipped}>
                  <div className='front' key='front'>
                    <img
                      src={CreditCardFrontImage}
                      alt='Cartão'
                      className='creditcard w-100'
                    />
                  </div>
                  <div className='back' key='back'>
                    <img
                      src={CreditCardBackImage}
                      alt='Cartão'
                      className='creditcard w-100'
                    />
                  </div>
                </ReactCardFlip>
              </div>
              {this.state.isBackCardVisible ? (
                <CreditCardBack {...creditCard} cvv={typeof brand !== 'undefined' && brand.name === 'AmericanExpress' ? '****' : '***'} />
              ) : (
                <CreditCardFront {...creditCard} cardBrand={cardBrand} />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CreditCard.propTypes = {
  payment: PropTypes.object.isRequired,
  creditCard: PropTypes.object.isRequired,
  handleCreditCardChange: PropTypes.func.isRequired,
  installmentSelected: PropTypes.func.isRequired,
  cardBrand: PropTypes.func.isRequired
}

export default CreditCard



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/CreditCard.js